"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var Stamp_1 = require("./Stamp");
var AcStampButton_1 = require("./AcStampButton");
var AcPdfEditorSideMenu_1 = require("../AcPdfEditorSideMenu");
exports.QUERY = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query AcDateStampQuery($id: Int!) {\n    viewer {\n      id\n      faxStamp(id: $id) {\n        id\n        faxStampId\n        type\n        companyContractFaxId\n        topPartName\n        middlePartFormat\n        bottomPartName\n      }\n    }\n  }\n"], ["\n  query AcDateStampQuery($id: Int!) {\n    viewer {\n      id\n      faxStamp(id: $id) {\n        id\n        faxStampId\n        type\n        companyContractFaxId\n        topPartName\n        middlePartFormat\n        bottomPartName\n      }\n    }\n  }\n"])));
exports.AcDateStampButton = function () {
    var setActiveMenu = react_1.useContext(AcPdfEditorSideMenu_1.AcPdfEditorSideMenuContext).setActiveMenu;
    var _a = client_1.useQuery(exports.QUERY, { variables: { id: -100 } }), loading = _a.loading, data = _a.data, error = _a.error;
    var getStamp = function (_data) {
        var _a;
        var faxStamp = (_a = _data === null || _data === void 0 ? void 0 : _data.viewer) === null || _a === void 0 ? void 0 : _a.faxStamp;
        if (!_data || (faxStamp === null || faxStamp === void 0 ? void 0 : faxStamp.type) !== 'DATE')
            return new Stamp_1.Stamp({ type: 'unknown' });
        return Stamp_1.Stamp.dateStamp({
            companyName: faxStamp.topPartName,
            dateFormat: faxStamp.middlePartFormat,
            userName: faxStamp.bottomPartName,
        });
    };
    var onClickSetting = function () {
        if (setActiveMenu) {
            setActiveMenu('dateStampMenu');
        }
    };
    return (react_1.default.createElement(AcStampButton_1.AcStampButton, { stamp: getStamp(data), width: 85, height: 85, size: "stamp_md", onClickSetting: onClickSetting, label: "\u30C7\u30FC\u30BF\u5370\uFF08\u65E5\u4ED8\u5370\uFF09" }));
};
AcStampButton_1.AcStampButton.displayName = 'AcStampButton';
var templateObject_1;
//# sourceMappingURL=AcDateStampButton.js.map